import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './AboutStep.module.scss';
import { ChallengeFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import { RichTextEditor } from '../../../../../../../shared/features/rich-text';
import { validateRichTextWhitespace } from '../../../../../../../shared/utils/reactHookFormUtils';

type Props = {
  onNext: () => void;
};

const AboutStep = ({ onNext }: Props) => {
  const { control, trigger } = useFormContext<ChallengeFormValues>();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = await trigger(['about.about', 'about.additionalInfo']);

    if (isValid) {
      onNext();
    }
  };

  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate className={classes.box}>
      <TitleWithDescription
        title="About"
        description="This is where you will let participants know details about your challenge. You can put rules here and information about upsells and other things that come with the challenge. Write bullet points and not long paragraphs."
        titleFont="title-16-bold"
      />
      <RichTextEditor
        size="small"
        control={control}
        label="About"
        name="about.about"
        rules={{
          required: 'About is required',
          validate: { validateRichTextWhitespace },
        }}
      />
      <TitleWithDescription
        title="What you'll need/additional info"
        description="Let participants know any additional info or things they will need to participate such as a smart phone, a gym membership, etc. Bullet points here are also recommended."
        titleFont="title-16-bold"
      />
      <RichTextEditor
        size="small"
        control={control}
        label="What you'll need/additional info"
        name="about.additionalInfo"
        rules={{
          required: 'Additional info is required',
          validate: { validateRichTextWhitespace },
        }}
      />
    </form>
  );
};

export { AboutStep };
